module.exports = __webpack_public_path__ + "img/adult-book-business-297755.78f00fad.jpg";